const keys = {
  adyenSwishAction: "hg::cache::adyenSwishAction",
}

export const swishPaymentId = "swish-wallet"

export const getAdyenSwishAction = (): {
  action: any
  clientKey: string
} | null => {
  const swishAction = localStorage.getItem(keys.adyenSwishAction)
  return swishAction ? JSON.parse(swishAction) : null
}

export const setAdyenSwishAction = (swishAction: {
  action: any
  clientKey: string
}) => {
  localStorage.setItem(keys.adyenSwishAction, JSON.stringify(swishAction))
}

export const deleteAdyenSwishAction = () => {
  localStorage.removeItem(keys.adyenSwishAction)
}
